import {Card, Flex, Box, Heading, Text} from '@chakra-ui/react';
import React from 'react';
import {CreditCostTag} from '../../App/CreditCostTag';

export const AgentBuilderCard = ({
  onClick,
  isDisabled,
  creditCost,
  description,
  label,
  AgentIcon,
}: {
  onClick?: () => void;
  isDisabled?: boolean;
  creditCost?: string | number;
  description: string;
  label: string;
  AgentIcon: React.ElementType;
}) => {
  const handleCardClick = () => {
    if (isDisabled) {
      return;
    }
    onClick?.();
  };

  return (
    <Card
      variant="outline"
      borderRadius="lg"
      h="100%"
      onClick={handleCardClick}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      _hover={isDisabled ? {} : {boxShadow: 'md', borderColor: 'kgray.200'}}
      bg={isDisabled ? 'kgray.100' : 'kgray.50'}
      borderColor="kgray.200"
      opacity={isDisabled ? 0.6 : 1}
    >
      <Flex p="4" direction="column" gap="10">
        <Flex justifyContent="space-between" alignItems="center">
          <AgentIcon color="kgray.200" boxSize="8" />
          {creditCost && <CreditCostTag creditCost={creditCost} />}
        </Flex>
        <Box>
          <Heading size="md" mb="2" fontWeight="medium">
            {label}
          </Heading>
          <Text fontSize="sm" color="kgray.300">
            {description}
          </Text>
        </Box>
      </Flex>
    </Card>
  );
};
